<script>
    import {http} from '../../http';
    export default {
        data: function () {
            return {
                paymentParams: {}
            };
        },
        props: {
            init_show_modal: {
                default: true
            },
            period: {
                required: true
            }
        },
        methods: {
            hide_modal(){
                $('#downgrade-notification-modal').modal('hide');
            },
            show_modal() {
                $('#downgrade-notification-modal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
                var self = this;
                $('#downgrade-notification-modal').on('hidden.bs.modal', function () {
                    self.save_hidde_modal();
                });
            },
            save_hidde_modal() {
                http.get('/app/settings/subscription/downgraded/hidde-modal');
            },
            add_credit_card() {
                new PaymentWindow(this.paymentParams).open();
            },
            load_orderlines() {
                http.get('/app/settings/subscription/orderlines', {
                    params: {
                        period: this.period.toLowerCase(),
                        action: 'reactivate'
                    }
                }).then(({data}) => {
                    this.paymentParams = data.paymentParams;
                }).catch(() => {});
            }
        },
        mounted: function () {
            this.load_orderlines();
            if (this.init_show_modal) {
                this.show_modal();
            }

            this.$event_bus.$on('showDowngradeModal', () => {
                this.show_modal();
            });
        }
    }
</script>
<template>
    <div class="modal-dialog">



        <div class="modal-content">

            <div class="modal-body p-0">
                <h1 class="text-center m-b-0">{{ trans('subscription.downgrade_modal_heading') }}</h1>

                <div class="text-center">

                    <div class="m-b-20 m-t-20">
                        <img src="/images/app/subscription/failed-payment.png" style="max-width:150px;margin-bottom:20px;" alt="">
                    </div>


                    <p>{{ trans('subscription.downgrade_modal_1') }}</p>
                    <p>{{ trans('subscription.downgrade_modal_2') }}</p>


                    <a  class="m-t-10 m-b-10 btn-custom btn btn-lg text-center" @click.prevent="$event_bus.$emit('showSubscriptionForm')"><i class="zmdi zmdi-check m-r-10"></i>{{ trans('subscription.downgrade_modal_cta') }}</a>

                    <small class="truncate m-t-10"><a href="" class="text-muted" @click.prevent="hide_modal"><u>{{ trans('settings.terms_and_dpa_consent_postpone_1') }}</u> {{ trans('settings.terms_and_dpa_consent_postpone_2') }}</a></small>


                </div>


            </div>
        </div>
    </div>
</template>
